module.exports = __webpack_public_path__ + "img/thumb_09.1b55e232.jpg";